import Vue from 'vue';
import Router from 'vue-router';

import Competitions from '../digiRegman/Competitions.vue';
import CompetitionDetail from '../digiRegman/CompetitionDetail.vue';
import QRScanner from '../digiRegman/QRScanner.vue';

Vue.use(Router);

const router = [{
	path: '/competitions',
	name: 'competitions',
	component: Competitions,
	meta: {
		requiresAuth: true,
	},
}, {
	path: '/competitions/:cId',
	name: 'addCompetitor',
	component: Competitions,
	meta: {
		requiresAuth: true,
	},
}, {
	path: '/competitiondetail/:cId',
	name: 'competitiondetail',
	component: CompetitionDetail,
	meta: {
		requiresAuth: true,
	},
}, {
	path: '/qr',
	name: 'qr',
	component: QRScanner,
	meta: {
		requiresAuth: true,
	},
}];

export default router;
